import React, { lazy } from 'react';
import { MapPinIcon, ClockIcon, PhoneIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function Location() {
  return <section className="py-24 px-6 bg-[#f5f4f1]" data-id="element-288">
      <div className="max-w-[1800px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-289">
        <div className="space-y-12" data-id="element-290">
          <div className="space-y-6" data-id="element-291">
            <span className="text-xs md:text-sm font-display font-bold uppercase tracking-[0.5em] text-black/40 block" data-id="element-292">
              The Atelier
            </span>
            <h2 className="text-xl sm:text-2xl md:text-4xl font-display font-bold tracking-widest uppercase leading-tight" data-id="element-293">
              Visit Us in <br data-id="element-294" /> Alexandria
            </h2>
            <p className="text-sm md:text-base font-light tracking-widest text-black/70 leading-relaxed uppercase" data-id="element-295">
              Experience the tactile beauty of our heritage textiles firsthand.
              Our studio offers private consultations, bespoke tailoring, and a
              curated preview of our latest collections.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-296">
            <div className="space-y-4" data-id="element-297">
              <h3 className="text-xs md:text-sm font-display font-bold tracking-widest uppercase text-black/40" data-id="element-298">
                Studio Address
              </h3>
              <p className="text-sm md:text-base font-light tracking-widest uppercase leading-relaxed" data-id="element-299">
                123 Heritage Lane <br data-id="element-300" />
                Alexandria, VA 22314
              </p>
            </div>
            <div className="space-y-4" data-id="element-301">
              <h3 className="text-xs md:text-sm font-display font-bold tracking-widest uppercase text-black/40" data-id="element-302">
                Studio Hours
              </h3>
              <p className="text-sm md:text-base font-light tracking-widest uppercase leading-relaxed" data-id="element-303">
                Mon - Fri: 10am - 6pm <br data-id="element-304" />
                Sat: 11am - 4pm
              </p>
            </div>
          </div>

          <Link to="/booking" className="inline-block bg-black text-white px-10 py-4 text-[10px] font-display font-bold uppercase tracking-widest hover:bg-black/80 transition-colors w-full md:w-auto text-center" data-id="element-305">
            Book a Consultation
          </Link>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative aspect-square md:aspect-video lg:aspect-square bg-grey-divider overflow-hidden grayscale contrast-125 border border-grey-divider" data-id="element-306">
          {/* Map for 101 S Whiting St, Alexandria, VA 22304 */}
          <iframe title="Djily Creations Studio Location" src="https://maps.google.com/maps?q=101%20S%20Whiting%20St%2C%20Alexandria%2C%20VA%2022304&t=&z=16&ie=UTF8&iwloc=&output=embed" width="100%" height="100%" style={{
          border: 0,
          filter: 'grayscale(1) contrast(1.2) invert(0)'
        }} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-307"></iframe>
          <div className="absolute inset-0 pointer-events-none border-[20px] border-white/10" data-id="element-308" />
        </motion.div>
      </div>
    </section>;
}